import { inputAlphanumericRule, maxLengthRule } from 'pages/private/components/form-utils';
import React from 'react';
import { TextFieldItem } from 'ui-lib';
import { DeviceAttributeName } from 'dto/device-dto';

export interface ITextFieldValidation {
    status: 'error' | 'success';
    message?: string;
}

export interface IDeviceTextAttribute {
    attributeName: DeviceAttributeName;
    attributeValue: string;
    textFieldValidation: ITextFieldValidation;
    onChange: (value: any) => void;
    onSaveAttribute: (value: string) => void;
}
export const TextAttributeItem = (props: IDeviceTextAttribute): React.ReactElement => {
    const { onSaveAttribute, attributeName, attributeValue, textFieldValidation } = props;
    const onlyLengthRule = maxLengthRule(32);
    const alphanumericRule = inputAlphanumericRule(undefined, ['UNDERSCORE']);
    const attributeRule = inputAlphanumericRule(800, ['UNDERSCORE']);

    return (
        <TextFieldItem
            code={attributeName}
            onPressEnter={() => {
                if (
                    (attributeName === 'esn' || attributeName === 'serialNumber') &&
                    (!attributeValue ||
                        !onlyLengthRule.pattern.test(attributeValue) ||
                        !alphanumericRule.pattern.test(attributeValue))
                ) {
                    return;
                }
                if (attributeValue !== '' && !attributeRule.pattern.test(attributeValue)) {
                    return;
                }
                onSaveAttribute(attributeValue);
            }}
            onChange={props.onChange}
            value={attributeValue}
            rule={
                props.attributeName === 'esn' || props.attributeName === 'serialNumber'
                    ? [alphanumericRule, onlyLengthRule]
                    : attributeRule
            }
            customizeValidate={textFieldValidation}
            initialValue={props.attributeValue}
            isRequired={
                (props.attributeName === 'esn' || props.attributeName === 'serialNumber') && !!props.attributeValue
            }
        />
    );
};
